// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications .alert{position:fixed;z-index:10000}.notifications .alert[data-notify=\"container\"]{width:480px;cursor:pointer}.notifications .alert.center{left:0px;right:0px;margin:0 auto}.notifications .alert.left{left:20px}.notifications .alert.right{right:20px}\n", ""]);
// Exports
module.exports = exports;
